import { twMerge } from "tailwind-merge";

const UserIcon = ({
    iconBackgroundColorClass,
    firstName,
    className,
}: {
    iconBackgroundColorClass?: string;
    firstName: string;
    className?: string;
}) => (
    <div
        className={twMerge(
            iconBackgroundColorClass || "bg-emerald-600",
            "flex h-5 min-h-5 w-5 min-w-5 items-center justify-center rounded-sm text-xs text-white",
            className,
        )}
    >
        {firstName.charAt(0).toUpperCase()}
    </div>
);

export default UserIcon;
